import { EventEmitter } from 'events';
import { TIMER_EVENTS } from './constants/timers.constants';

export function waitUntil(time: number, stopper?: EventEmitter): Promise<boolean> {
  return new Promise((resolve) => {
    let timer: ReturnType<typeof setTimeout>;
    function done(wasInterrupted = true) {
      resolve(!wasInterrupted);
      stopper?.removeListener?.(TIMER_EVENTS.STOP, done);
      if (timer) clearTimeout(timer);
    }

    stopper?.once?.(TIMER_EVENTS.STOP, done);
    timer = setTimeout(done, time, false);
  });
}
